import { VendorActionsAppComponent } from './vendor.actions.component';

export function VendorsCtrl (
  $scope,
  companyMessages,
  inheritorApi,
  vendors
) {
  $scope.companyMessages = companyMessages;
  $scope.vendors         = vendors;

  inheritorApi.inheritCtrl('VendorsLiteCtrl', $scope);

  $scope.tableSettings.columns[$scope.tableSettings.columns.length - 1] = {
    component: {
      bindings: {
        outputs: {
          onEditClick         : event => $scope.viewVendor(event),
          onInvoiceClick      : event => $scope.createInvoice(event),
          onPurchaseOrderClick: event => $scope.createPurchaseOrder(event),
          onPaymentClick      : event => $scope.createPayment(event),
          onSMSClick          : event => $scope.sendSMS(event),
          onEmailClick        : event => $scope.sendEmail(event),
          onActivateClick     : event => $scope.activate(event)
        }
      },
      enabled: true,
      factory: VendorActionsAppComponent,
    },
    sortable: false,
  }
}